import { FormModelField, ComboList } from './../../../utils/index';
import { Validators } from './../../../validators/index';
import {
  trigger,
  transition,
  style,
  animate,
  state
} from '@angular/animations';
import {
  IFormModelField,
  IComboList
} from './../../../interfaces/forms.interface';
import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  OnChanges,
  SimpleChanges,
  AfterViewInit,
  EventEmitter,
  Output
} from '@angular/core';
import * as moment from 'moment';
import { of, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'siu-form-model-field',
  templateUrl: './form-model-field.component.html',
  styleUrls: ['./form-model-field.component.scss']
})
export class FormModelFieldComponent
  implements OnInit, OnChanges, AfterViewInit {
  @Input() variant:
    | 'text'
    | 'check'
    | 'multiline'
    | 'select'
    | 'multiselect'
    | 'mask'
    | 'datepicker' = 'text';
  @Input() label: string;
  @Input() formModelField: IFormModelField = null;
  @Input() fullWidth: boolean = true;
  @Input() placeholder: string = '';
  @Input() maxDate: any = null;
  @Input() minDate: any = moment('1900-01-01');
  @Input() readonly: boolean = false;
  @Input() options: IComboList = new ComboList([]);
  @Input() bindLabel: string = 'label';
  @Input() bindValue: string = 'value';
  @Input() appendToBody: boolean = true;
  @Input() maxItems: number = 5;
  @Input() maxSelectedLabels: number = 4;
  @Input() showCharCount: boolean = false;
  @Input() size: 'normal' | 'sm' = 'normal';
  @Input() showErrorsMargin: boolean = true;
  @Input() hideLabel: boolean = false;
  @Input() disabled: boolean = false;
  @Input() typeValor: string = '';
  @Input() esRequerido: boolean = false;
  @Input() maskValor: Array<string | RegExp> = null;
  @Input() clearMessage: boolean = false;

  isRequired: boolean = false;
  maxLengthNumber: number;
  @ViewChild('formFieldInput', null) formFieldInput: ElementRef<HTMLInputElement>;
  @Input() inputProps: { [key: string]: string } = {};
  @Output('on-change') onChangeEvent: EventEmitter<any> = new EventEmitter();
  modelValue: any;
  @Input() get model() {
    return this.modelValue;
  }

  set model(val) {
    if (this.formModelField) {
      this.formModelField.setValue(val);
    }
    this.modelValue = val;
    this.modelChange.emit(this.model);
  }
  @Output() modelChange: EventEmitter<any> = new EventEmitter();
  standalone: boolean = false;
  errorOnLoad: boolean = false;

  VARIANT_TYPE = {
    text: 'text',
    text2: 'text2',
    text3: 'text3',
    multiline: 'multiline',
    select: 'select',
    multiselect: 'multiselect',
    datepicker: 'datepicker',
    check: 'check',
    numero: 'numero',
    decimal2: 'decimal2',
    mask: 'mask'
  };

  constructor() { }

  ngOnInit() {
    if (this.formModelField === undefined) {
      this.errorOnLoad = true;
      console.error('La propiedad enlazada no existe en el modelo');
    } else {
      if (this.formModelField) {
        this.checkIsRequired();
        this.formModelField.setFieldLabel(this.label);
        if (this.esRequerido) { this.isRequired = this.esRequerido }
      } else {
        this.standalone = true;
        this.formModelField = new FormModelField(
          this.model,
          false,
          false,
          true,
          [],
          [],
          '',
          this.label,
          '',
        );
      }
    }
  }

  ngAfterViewInit(): void {
    this._setInputAttributes();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.inputProps &&
      !changes.inputProps.firstChange &&
      changes.inputProps.currentValue
    ) {
      this._setInputAttributes();
    }
  }

  private checkIsRequired = () => {
    if (this.formModelField.rules && this.formModelField.rules.length > 0) {
      this.isRequired =
        this.formModelField.rules.filter(
          x => x.toString() == Validators.required.toString()
        ).length > 0;
    }
  };

  private _setInputAttributes() {
    if (this.formFieldInput) {
      const input = this.formFieldInput.nativeElement;
      const attributes = {
        type: 'text',
        autocorrect: 'off',
        autocapitalize: 'off',
        autocomplete: 'off',
        maxlength: 255,
        // autocomplete: this.labelForId ? 'off' : this.dropdownId,
        ...this.inputProps
      };

      setTimeout(() => {
        this.maxLengthNumber = attributes.maxlength;
      });

      for (const key of Object.keys(attributes)) {
        input.setAttribute(key, attributes[key]);
      }
    }
  }

  HandleClearValue = () => {
    this.formModelField.setValue(null);
    this.emitChange(null);
  };

  handleModelChange = e => {
    this.emitChange(e);
  };

  handleChangeSelect = e => {
    const value = !e
      ? null
      : Array.isArray(e)
        ? e.map(x => x[this.bindValue])
        : e[this.bindValue];
    this.emitChange(value, e);
  };

  private emitChange = (value, selected = null) => {
    this.formModelField.validate();
    if (this.standalone) {
      this.model = value;
    }

    const name = `${this.formModelField.parentPrefix}${this.formModelField.parentPrefix ? '.' : ''
      }${this.formModelField.fieldName}`;

    this.onChangeEvent.emit({
      value,
      name,
      selected
    });
  };
}
